import { TJobAlertState } from '.'
import { GET_JOB_ALERT_ERROR, GET_JOB_ALERT_REQUEST, GET_JOB_ALERT_SUCCESS } from './constant'

const jobAlertReducer = (state: TJobAlertState, action: any) => {
    switch (action.type) {
        case GET_JOB_ALERT_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case GET_JOB_ALERT_SUCCESS: {
            return {
                first: false,
                error: '',
                loading: false,
                data: action.payload
            }
        }
        case GET_JOB_ALERT_ERROR: {
            return {
                first: false,
                error: action.payload,
                loading: false,
                data: []
            }
        }
        default:
            return state
    }
}

export default jobAlertReducer
